var moment = require('moment')
var dateutils = require('./dateutils')

const state = {
  all: [],
  headers: ['status', 'name', 'totalPrizeMoney', 'startDate', 'endDate', 'invoiceStartDate', 'invoiceEndDate', 'minimumPrice', 'description', 'campaignImageUrl', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'campaignId', 'demo'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showUpdatingStatusModal: false,
  showChangeStatusModal: false,
  showUpdateSuccessModal: false,
  showUpdateFailModal: false,
  showEditCampaignModal: false,
  editedCampaign: {
    campaignId: '',
    name: '',
    description: '',
    campaignImageUrl: '',
    campaignImageStoragePath: '',
    bannerFile: null,
    campaignStartDate: null,
    campaignEndDate: null,
    invoiceStartDate: null,
    invoiceEndDate: null,
    minimumInvoicePerPiece: 0,
    eligibleOrderTypes: [],
    availableEligibleOrderTypes: [],
    eligibleLensDesigns: [],
    availableEligibleLensDesigns: [],
    eligibleLensIndexes: [],
    availableEligibleLensIndexes: [],
    notesPool: [],
    editedIsDemoAccount: false
  },
  showCampaignLiveModal: false,
  campaignMoneyPool: {
    claimedPrizeMoney: 0,
    totalPrizeMoney: 0,
    notesPool: []
  },
  realtimeCampaignRef: null,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
}

function getRewardValue (reward) {
  return Number(reward && (reward.rewardValue || reward.noteType) || 0)
}

function getRewardQuantity (reward) {
  return Number(reward && (reward.totalQuantity || reward.noteAmount) || 0)
}

function getRewardLabel (reward) {
  if (!reward) {
    return 'Voucher'
  }
  if (reward.rewardLabel && reward.rewardLabel.length > 0) {
    return reward.rewardLabel
  }
  let rewardValue = getRewardValue(reward)
  return rewardValue > 0 ? 'RM ' + rewardValue : 'Voucher'
}

function getRewardClaimedQuantity (reward) {
  return Number(reward && (reward.claimedQuantity || reward.claimedAmount) || 0)
}

function getRewardId (reward, index) {
  if (reward && reward.rewardId && String(reward.rewardId).length > 0) {
    return reward.rewardId
  }
  let rewardLabel = getRewardLabel(reward)
  return rewardLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + index
}

function normaliseReward (reward, index) {
  let rewardValue = getRewardValue(reward)
  let rewardQuantity = getRewardQuantity(reward)
  let claimedQuantity = getRewardClaimedQuantity(reward)
  let rewardLabel = getRewardLabel(reward)
  return {
    rewardId: getRewardId(reward, index),
    rewardLabel: rewardLabel,
    rewardType: reward && reward.rewardType ? reward.rewardType : (rewardValue > 0 ? 'MONEY' : 'VOUCHER'),
    rewardValue: rewardValue,
    totalQuantity: rewardQuantity,
    claimedQuantity: claimedQuantity,
    noteType: String(rewardValue),
    noteAmount: rewardQuantity,
    claimedAmount: claimedQuantity
  }
}

function normaliseRewards (rewards) {
  let notesPool = []
  if (!rewards) {
    return notesPool
  }
  for (let i = 0; i < rewards.length; i++) {
    notesPool.push(normaliseReward(rewards[i], i))
  }
  return notesPool
}

function calculateRewardTotal (notesPool) {
  let total = 0
  for (let i = 0; i < notesPool.length; i++) {
    total += Number(notesPool[i].rewardValue || 0) * Number(notesPool[i].totalQuantity || 0)
  }
  return total
}

function validateRewards (editedRewards, liveRewards) {
  if (!editedRewards || editedRewards.length === 0) {
    return 'Please add at least one reward.'
  }

  let liveById = {}
  if (liveRewards) {
    for (let i = 0; i < liveRewards.length; i++) {
      let liveReward = normaliseReward(liveRewards[i], i)
      liveById[liveReward.rewardId] = liveReward
    }
  }

  let editedById = {}
  for (let i = 0; i < editedRewards.length; i++) {
    let reward = editedRewards[i]
    if (!reward.rewardLabel || String(reward.rewardLabel).trim().length === 0) {
      return 'Reward name cannot be empty.'
    }
    if (Number(reward.rewardValue) < 0 || isNaN(Number(reward.rewardValue))) {
      return 'Reward cash value must be 0 or more.'
    }
    if (Number(reward.totalQuantity) < 0 || isNaN(Number(reward.totalQuantity))) {
      return 'Reward quantity must be 0 or more.'
    }

    let liveReward = liveById[reward.rewardId]
    if (liveReward) {
      reward.rewardType = liveReward.rewardType
      reward.rewardValue = liveReward.rewardValue
      reward.noteType = liveReward.noteType
      reward.claimedQuantity = getRewardClaimedQuantity(liveReward)
      reward.claimedAmount = reward.claimedQuantity
      if (Number(reward.totalQuantity) < Number(reward.claimedQuantity)) {
        return 'Reward "' + reward.rewardLabel + '" already has ' + reward.claimedQuantity + ' claimed piece(s). Quantity cannot be lower than claimed.'
      }
    }
    editedById[reward.rewardId] = reward
  }

  for (let rewardId in liveById) {
    if (liveById.hasOwnProperty(rewardId) && Number(liveById[rewardId].claimedQuantity) > 0 && !editedById[rewardId]) {
      return 'Reward "' + liveById[rewardId].rewardLabel + '" has claims already. It cannot be deleted.'
    }
  }

  return ''
}

function normalizeLensIndex (lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return ''
  }

  let value = String(lensIndex).trim()
  if (value.length === 0) {
    return ''
  }

  let numericValue = Number(value)
  return isNaN(numericValue) ? value : numericValue.toFixed(2)
}

function normalizeLensIndexes (lensIndexes) {
  let normalised = []
  if (!lensIndexes) {
    return normalised
  }

  for (let i = 0; i < lensIndexes.length; i++) {
    let lensIndex = normalizeLensIndex(lensIndexes[i])
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex)
    }
  }
  return normalised
}

function cleanFileName (fileName) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_')
}

function uploadEditedCampaignBanner (context) {
  if (!context.state.editedCampaign.bannerFile) {
    return Promise.resolve({
      campaignImageUrl: context.state.editedCampaign.campaignImageUrl || '',
      campaignImageStoragePath: context.state.editedCampaign.campaignImageStoragePath || ''
    })
  }

  let fileName = Date.now() + '_' + cleanFileName(context.state.editedCampaign.bannerFile.name)
  let storagePath = 'campaignBanners/' + fileName
  let storageRef = context.rootState.fbStorage.ref().child(storagePath)

  return storageRef.put(context.state.editedCampaign.bannerFile).then(function (snapshot) {
    return snapshot.ref.getDownloadURL()
  }).then(function (downloadURL) {
    return {
      campaignImageUrl: downloadURL,
      campaignImageStoragePath: storagePath
    }
  })
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    console.log('Mutated totalRows to: ' + state.totalRows)
  },
  selectTableRow: function (state, selectedCampaignId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].campaignId === selectedCampaignId) {
        state.all[i]._rowVariant = 'info'
        console.log('selected selectedCampaignId:' + selectedCampaignId)
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowUpdatingStatusModal: function (state, show) {
    state.showUpdatingStatusModal = show
  },
  toggleShowChangeStatusModal: function (state, show) {
    state.showChangeStatusModal = show
    console.log('showChangeStatusModal: ' + state.showChangeStatusModal)
  },
  toggleshowUpdateSuccessModal: function (state, show) {
    state.showUpdateSuccessModal = show
  },
  toggleShowUpdateFailModal: function (state, show) {
    state.showUpdateFailModal = show
  },
  toggleShowEditCampaignModal: function (state, show) {
    state.showEditCampaignModal = show
  },
  updateNewCampaignId: function (state, newId) {
    state.editedCampaign.campaignId = newId
  },
  updateNewCampaignName: function (state, newName) {
    state.editedCampaign.name = newName
  },
  updateNewCampaignDescription: function (state, newDescription) {
    state.editedCampaign.description = newDescription
  },
  updateNewCampaignImageUrl: function (state, newImageUrl) {
    state.editedCampaign.campaignImageUrl = newImageUrl || ''
  },
  updateNewCampaignImageStoragePath: function (state, newStoragePath) {
    state.editedCampaign.campaignImageStoragePath = newStoragePath || ''
  },
  updateEditedCampaignBannerFile: function (state, file) {
    state.editedCampaign.bannerFile = file
  },
  updateNewCampaignStartDate: function (state, dateString) {
    console.debug('Updating campaign start date to: ' + dateString)
    let m = dateutils.parseDateTime(dateString)
    state.editedCampaign.campaignStartDate = m
    console.debug('Updated campaign start date to: ' + state.editedCampaign.campaignStartDate.toDate())
  },
  updateNewCampaignEndDate: function (state, dateString) {
    console.debug('Updating campaign end date to: ' + dateString)
    let m = dateutils.parseDateTime(dateString)
    state.editedCampaign.campaignEndDate = m
    console.debug('Updated campaign end date to: ' + state.editedCampaign.campaignEndDate.toDate())
  },
  updateNewInvoiceStartDate: function (state, dateString) {
    console.debug('Updating invoice start date to: ' + dateString)
    let m = dateutils.parseDateTime(dateString)
    state.editedCampaign.invoiceStartDate = m
    console.debug('Updated invoice start date to: ' + state.editedCampaign.invoiceStartDate.toDate())
  },
  updateNewInvoiceEndDate: function (state, dateString) {
    console.debug('Updating invoice end date to: ' + dateString)
    let m = dateutils.parseDateTime(dateString)
    state.editedCampaign.invoiceEndDate = m
    console.debug('Updated invoice end date to: ' + state.editedCampaign.invoiceEndDate.toDate())
  },
  updateminimumInvoicePerPiece: function (state, newMinimumInvoicePerPiece) {
    state.editedCampaign.minimumInvoicePerPiece = newMinimumInvoicePerPiece
  },
  updateEligibleLenseDesigns: function (state, newValues) {
    state.editedCampaign.eligibleLensDesigns = newValues
  },
  updateEligibleOrderTypes: function (state, newValues) {
    state.editedCampaign.eligibleOrderTypes = newValues
  },
  updateEligibleLensIndexes: function (state, newValues) {
    state.editedCampaign.eligibleLensIndexes = newValues
  },
  updateEditedCampaignRewards: function (state, notesPool) {
    state.editedCampaign.notesPool = normaliseRewards(notesPool || [])
  },
  addEditedCampaignReward: function (state) {
    state.editedCampaign.notesPool.push(normaliseReward({
      rewardLabel: '',
      rewardType: 'VOUCHER',
      rewardValue: 0,
      totalQuantity: 1,
      claimedQuantity: 0
    }, state.editedCampaign.notesPool.length))
  },
  removeEditedCampaignReward: function (state, index) {
    state.editedCampaign.notesPool.splice(index, 1)
  },
  updateEditedIsDemoAccount: function (state, editedIsDemoAccount) {
    state.editedCampaign.editedIsDemoAccount = editedIsDemoAccount
  },
  toggleShowCampaignLiveModal: function (state, show) {
    state.showCampaignLiveModal = show
  },
  turnOffLiveCampignListener: function (state) {
    if (state.realtimeCampaignRef) {
      state.realtimeCampaignRef.off()
    }
  },
  updateLiveCampaignObject: function (state, snapshotValue) {
    state.campaignMoneyPool.claimedPrizeMoney = snapshotValue.claimedPrizeMoney
    state.campaignMoneyPool.totalPrizeMoney = snapshotValue.totalPrizeMoney
    state.campaignMoneyPool.notesPool = snapshotValue.notesPool
  },
  toggleShowHideRowDetail: function (state, campaignId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].campaignId === campaignId) {
        if (state.all[i]._showDetails === true) {
          state.all[i]._showDetails = false
        } else {
          state.all[i]._showDetails = true
        }
      }
    }
  },
  addOrderType: function (state, orderType) {
    state.editedCampaign.availableEligibleOrderTypes.push(orderType)
    // console.log('state.availableOrderTypes:' + state.availableOrderTypes)
  },
  addLensDesign: function (state, lensDesign) {
    state.editedCampaign.availableEligibleLensDesigns.push(lensDesign)
  },
  addLensIndex: function (state, lensIndex) {
    let normalisedLensIndex = normalizeLensIndex(lensIndex)
    if (normalisedLensIndex.length > 0 && state.editedCampaign.availableEligibleLensIndexes.indexOf(normalisedLensIndex) === -1) {
      state.editedCampaign.availableEligibleLensIndexes.push(normalisedLensIndex)
    }
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  },
  getEditedCampaignStartDate: function (state, getters, rootState) {
    if (!state.editedCampaign.campaignStartDate) {
      return ''
    }
    let dateString = state.editedCampaign.campaignStartDate.format('DD/MMM/YYYY hh:mm:ss a')
    return dateString
  },
  getEditedCampaignEndDate: function (state, getters, rootState) {
    if (!state.editedCampaign.campaignEndDate) {
      return ''
    }
    let dateString = state.editedCampaign.campaignEndDate.format('DD/MMM/YYYY hh:mm:ss a')
    return dateString
  },
  getEditedCampaignInvoiceStartDate: function (state, getters, rootState) {
    if (!state.editedCampaign.invoiceStartDate) {
      return ''
    }
    let dateString = state.editedCampaign.invoiceStartDate.format('DD/MMM/YYYY hh:mm:ss a')
    return dateString
  },
  getEditedCampaignInvoiceEndDate: function (state, getters, rootState) {
    if (!state.editedCampaign.invoiceEndDate) {
      return ''
    }
    let dateString = state.editedCampaign.invoiceEndDate.format('DD/MMM/YYYY hh:mm:ss a')
    return dateString
  }
}

const actions = {
  fetchAvailableOrderTypesFromFirestore (context) {
    context.state.editedCampaign.availableEligibleOrderTypes = []

    let firstQuery = context.rootState.firestoreDB.collection('orderTypes').orderBy('orderType')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        // console.log('fetched: ' + doc.data().orderType)
        context.commit('addOrderType', doc.data().orderType)
      })
    })
  },
  fetchAvailableLensDesignsFromFirestore (context) {
    context.state.editedCampaign.availableEligibleLensDesigns = []

    let firstQuery = context.rootState.firestoreDB.collection('lensDesigns').orderBy('lensDesign')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        // console.log('fetched: ' + doc.data().lensDesign)
        context.commit('addLensDesign', doc.data().lensDesign)
      })
    })
  },
  fetchAvailableLensIndexesFromFirestore (context) {
    context.state.editedCampaign.availableEligibleLensIndexes = []

    let firstQuery = context.rootState.firestoreDB.collection('lensIndexes').orderBy('lensIndex')
    firstQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(doc => {
        context.commit('addLensIndex', doc.data().lensIndex)
      })
    })
  },
  showAllCampaigns (context, payload) {
    context.state.all = []
    // context.state.headers = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    // count total rows
    let firstQuery = context.rootState.firestoreDB.collection('campaigns')
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length)
    })

    if (context.state.currentPage === 1) {
      let docQuery = context.rootState.firestoreDB.collection('campaigns')
        .orderBy(payload.orderBys)
        .limit(context.state.rowsPerPage)
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id + '=>' + doc.data())
          let documentData = doc.data()
          let invoiceObject = {}
          for (let eachProp in documentData) {
            let propName = eachProp
            // console.log('eachProp: ' + eachProp)
            if (propName === 'startDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'endDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'invoiceStartDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'invoiceEndDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'createdDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else {
              invoiceObject[propName] = doc.data()[eachProp]
            }
            // invoiceObject[propName] = doc.data()[eachProp]
            // context.state.headers.push(propName)
          }
          invoiceObject['_showDetails'] = false
          invoiceObject.campaignId = doc.id
          invoiceObject._rowVariant = ''
          context.state.all.push(invoiceObject)
        })
        context.commit('toggleShowLoadingAnimation', false)
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true)
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in campaigns collection: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    } else {
      let lastRowShown
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage
      } else {
        lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
      }
      console.log('lastRowShown: ' + lastRowShown)
      let docQuery = context.rootState.firestoreDB.collection('campaigns')
        .orderBy(payload.orderBys)
      docQuery.get().then(function (querySnapshot) {
        let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]

        let docSubQuery = context.rootState.firestoreDB.collection('campaigns')
          .orderBy(payload.orderBys)
          .startAt(lastVisibleSnapshot)
          .limit(context.state.rowsPerPage)
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            // console.log(subDoc.id + '=>' + subDoc.data())
            let documentData = subDoc.data()
            let invoiceObject = {}
            for (let eachProp in documentData) {
              let propName = eachProp
              // console.log('eachProp: ' + eachProp)
              if (propName === 'startDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'endDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'invoiceStartDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'invoiceEndDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp]
              }
              // invoiceObject[propName] = subDoc.data()[eachProp]
              // context.state.headers.push(propName)
            }
            invoiceObject['_showDetails'] = false
            invoiceObject.campaignId = subDoc.id
            invoiceObject._rowVariant = ''
            context.state.all.push(invoiceObject)
          })
          context.commit('toggleShowLoadingAnimation', false)
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true)
          }
        })
      }).catch(function (err) {
        console.log('Error while fetching documents in campaigns collection: ' + err)

        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    }
  },
  updateCampaignStatus (context, payload) {
    if (!payload.newStatus || payload.newStatus.length === 0) {
      console.error('status cannot be empty')
      return
    }
    context.commit('toggleShowUpdatingStatusModal', true)
    console.log('Update campaign: ' + payload.campaignId + ' status to: ' + payload.newStatus)

    if (payload.newStatus === 'ACTIVE' || payload.newStatus === 'DEMO_ACTIVE') {
      console.log('Adding counters to realtime db')
      let campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId)
      campaignRef.once('value').then(function (snapshot) {
        console.log('snapshot.val():' + snapshot.val())
        if (snapshot.val() == null) {
          console.log('Adding new campaign to realtime db...')
          let notesPool = []
          if (payload.notesPool) {
            for (let i = 0; i < payload.notesPool.length; i++) {
              let note = payload.notesPool[i]
              notesPool.push(normaliseReward(note, i))
            }
          }
          campaignRef.set({
            campaignId: payload.campaignId,
            totalPrizeMoney: calculateRewardTotal(notesPool),
            claimedPrizeMoney: 0,
            notesPool: notesPool
          }).catch(function (err) {
            console.error('Error while creating realtime campaign: ' + err)
          })
        } else {
          console.log('already have campaign data in realtime db, not creating another...')
        }
      })
    }

    let docRef = context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId)
    docRef.update({
      status: payload.newStatus,
      updatedBy: 'admin',
      updatedDate: new Date()
    }).then(function () {
      context.commit('toggleShowChangeStatusModal', false)
      context.commit('toggleShowUpdatingStatusModal', false)
      context.commit('toggleshowUpdateSuccessModal', true)
      context.dispatch('showAllCampaigns', { orderBys: 'createdDate' })
    }).catch(function (err) {
      console.log('Error while updating campaign status: ' + err)
      context.commit('setLoadingErrorMessage', err && err.message ? err.message : 'Update failed')
      context.commit('toggleShowUpdatingStatusModal', false)
      context.commit('toggleShowUpdateFailModal', true)
    })
  },
  fetchEditedCampaignLiveRewards (context, payload) {
    if (!payload || !payload.campaignId) {
      return
    }
    let campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId)
    campaignRef.once('value').then(function (snapshot) {
      let liveCampaign = snapshot.val()
      if (liveCampaign && liveCampaign.notesPool) {
        context.commit('updateEditedCampaignRewards', liveCampaign.notesPool)
      }
    }).catch(function (err) {
      console.log('Error while fetching live rewards for campaign edit: ' + err)
    })
  },
  updateCampaign (context, payload) {
    context.commit('toggleShowUpdatingStatusModal', true)
    console.log('Update campaign, name: ' + context.state.editedCampaign.name +
      ' description:' + context.state.editedCampaign.description +
      ' start date:' + context.state.editedCampaign.campaignStartDate.format('DD/MMM/YYYY hh:mm:ss a') +
      ' end date:' + context.state.editedCampaign.campaignEndDate.format('DD/MMM/YYYY hh:mm:ss a') +
      ' invoice start date:' + context.state.editedCampaign.invoiceStartDate.format('DD/MMM/YYYY hh:mm:ss a') +
      ' invoice end data:' + context.state.editedCampaign.invoiceEndDate.format('DD/MMM/YYYY hh:mm:ss a') +
      ' minimum price:' + context.state.editedCampaign.minimumInvoicePerPiece +
      ' id: ' + payload.campaignId)
    console.log('Update campaign, name: ' + context.state.editedCampaign.name +
      ' new eligible order types: ' + context.state.editedCampaign.eligibleOrderTypes +
      ' new eligible lens designs: ' + context.state.editedCampaign.eligibleLensDesigns +
      ' new eligible lens indexes: ' + context.state.editedCampaign.eligibleLensIndexes)

    let docRef = context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId)
    let campaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId)
    let notesPool = normaliseRewards(context.state.editedCampaign.notesPool)
    let totalPrizeMoney = calculateRewardTotal(notesPool)
    let liveCampaignData = null

    uploadEditedCampaignBanner(context).then(function (bannerInfo) {
      return campaignRef.once('value').then(function (snapshot) {
        liveCampaignData = snapshot.val()
        let validationMessage = validateRewards(notesPool, liveCampaignData ? liveCampaignData.notesPool : null)
        if (validationMessage) {
          throw new Error(validationMessage)
        }
        return bannerInfo
      })
    }).then(function (bannerInfo) {
      return context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, {
            name: context.state.editedCampaign.name,
            description: context.state.editedCampaign.description,
            campaignImageUrl: bannerInfo.campaignImageUrl,
            campaignImageStoragePath: bannerInfo.campaignImageStoragePath,
            startDate: context.state.editedCampaign.campaignStartDate.toDate(),
            endDate: context.state.editedCampaign.campaignEndDate.toDate(),
            invoiceStartDate: context.state.editedCampaign.invoiceStartDate.toDate(),
            invoiceEndDate: context.state.editedCampaign.invoiceEndDate.toDate(),
            minimumPrice: context.state.editedCampaign.minimumInvoicePerPiece,
            orderTypes: context.state.editedCampaign.eligibleOrderTypes,
            lensDesigns: context.state.editedCampaign.eligibleLensDesigns,
            lensIndexes: normalizeLensIndexes(context.state.editedCampaign.eligibleLensIndexes),
            notesPool: notesPool,
            totalPrizeMoney: totalPrizeMoney,
            demo: context.state.editedCampaign.editedIsDemoAccount
          })
        }
      })
      })
    }).then(function () {
      if (liveCampaignData) {
        return campaignRef.update({
          notesPool: notesPool,
          totalPrizeMoney: totalPrizeMoney
        })
      }
    }).then(function () {
      console.log('campaign updated')
      context.dispatch('showAllCampaigns', {orderBys: 'createdDate'})
      context.commit('toggleShowChangeStatusModal', false)
      context.commit('toggleShowUpdatingStatusModal', false)
      context.commit('toggleshowUpdateSuccessModal', true)
      context.commit('toggleShowEditCampaignModal', false)
    }).catch(function (err) {
      console.log('Error while updating campaign: ' + err)
      context.commit('setLoadingErrorMessage', err && err.message ? err.message : 'Update failed')
      context.commit('toggleShowUpdatingStatusModal', false)
      context.commit('toggleShowUpdateFailModal', true)
      context.commit('toggleShowEditCampaignModal', false)
    })
  },
  showCampaignMoneyPool (context, payload) {
    if (context.state.realtimeCampaignRef) {
      context.state.realtimeCampaignRef.off()
    }

    state.campaignMoneyPool.claimedPrizeMoney = 0
    state.campaignMoneyPool.totalPrizeMoney = 0
    state.campaignMoneyPool.notesPool = []

    context.state.realtimeCampaignRef = context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId)
    context.state.realtimeCampaignRef.on('value', function (snapshot) {
      if (snapshot && snapshot.val()) {
        context.commit('updateLiveCampaignObject', snapshot.val())
      }
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/campaignstoremodule.js